<template>
    <div class="kgk-user-change-password">
        <h2 v-if="!insideModal">
            Passwort ändern
        </h2>
        <form @submit.prevent="performUpdate">
            <div class="kgk-form-row">
                Aktuelles Passwort
                <div class="kgk-input-group">
                    <input type="password" v-model="passwordOld" name="password-old">
                </div>
                <div v-if="showValidationErrors && !passwordOldRequiredValidation" class="kgk-form-validation-error-inline">Bitte gib aus Sicherheitsgründen dein bisheriges Passwort an.</div>
            </div>
            <br>
            <div class="kgk-form-row">
                Dein neues Passwort
                <div class="kgk-input-group">
                    <input type="password" v-model="form.password" name="password">
                </div>
                <div v-if="showValidationErrors && !passwordLengthValidation" class="kgk-form-validation-error-inline">Passwort muss mindestens 8 Zeichen haben.</div>
            </div>
            <div class="kgk-form-row">
                Passwort bestätigen
                <div class="kgk-input-group">
                    <input type="password" v-model="passwordConfirm" name="password-confirmation">
                </div>
                <div v-if="!passwordEqualityValidation" class="kgk-form-validation-error-inline">Passwörter stimmen nicht überein</div>
            </div>
            <div v-if="!insideModal" class="kgk-form-row">
                <button type="submit">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span class="button-text">Passwort ändern</span>
                </button>
            </div>

            <!--<p>
                Blub Blub / Reset code: {{ resetCode }}
            </p>-->
        </form>
    </div>
</template>

<script>
    import user from '../../api/user';
    //import router from '../../router';

    export default {
        name: 'UserChangePasswordForm',
        components: {

        },
        props: {
            insideModal: {
                type: Boolean,
                //required: true,
                default: false,
            },
            modalSaveTrigger: {
                type: Object,
                required: false
            },
        },
        data() {
            return {
                loading: false,
                form: {
                    password: '',
                },
                passwordConfirm: '',
                passwordOld: '',
                showValidationErrors: false,
                error: '',
            }
        },
        computed: {
            passwordOldRequiredValidation() {
                return this.passwordOld.length > 0;
            },
            passwordLengthValidation() {
                return this.form.password.length >= 8;
            },
            passwordEqualityValidation() {
                if( this.form.password.length == 0 || this.passwordConfirm.length == 0 ) {
                    return true;
                }

                return this.form.password === this.passwordConfirm;
            }
        },
        methods: {
            performUpdate(/*calledFromModal*/) {
                //calledFromModal = calledFromModal || false;

                if( this.loading ) {
                    return;
                }

                this.showValidationErrors = true;

                if( !this.passwordOldRequiredValidation
                    || !this.passwordLengthValidation
                    || !this.passwordEqualityValidation) {
                    this.$notify({
                        type: 'warn',
                        title: 'Eingaben fehlerhaft.',
                        text: 'Bitte korrigiere deine Formulareingaben.'
                    });

                    return;
                }

                this.loading = true;

                this.$emit('loadingStarted');

                user.changePassword(
                    this,
                    this.form.password,
                    this.passwordOld,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Passwort geändert',
                            text: 'Dein Passwort wurde erfolgreich geändert.'
                        });

                        this.$emit('changed');

                        //router.push('/login');
                    },
                    e => {
                        //console.error(e.response.status);

                        if( e.response.status == 400 || typeof e.response.data.message !== 'undefined' ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        this.loading = false;
                        this.$emit('loadingEnded');
                    }
                );
            },

        },
        watch: {
            'modalSaveTrigger.trigger'() {
                this.performUpdate();
            },
        },
        mounted() {

        }
    }
</script>

